/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';
import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';
// I18n
import { TParams } from '@global-types/index';
import { useTranslation } from 'react-i18next';
import { TAdditionalityProject } from '../types';

export const remove = (
	id: string
): Promise<TAdditionalityProject> => {
	return apiClient.delete(`/additionalities/${id} `);
};

export const useRemove = (
	page: number,
	size: number,
	queryParams: TParams,
	sortParams: string
) => {
	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: remove,
		onSuccess: () => {
			notifications.show({
				title: t('global.success'),
				message: t(
					'additionalities.notifications.additionalitiesSuccessfullyDeleted'
				),
				color: 'var(--mantine-color-igluGreen-9)',
			});
			queryClient.invalidateQueries({
				queryKey: [
					'databases-additionalities',
					{
						page: page,
						size: size,
						queryParams: queryParams,
						sortParams: sortParams,
					},
				],
			});
		},
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'var(--mantine-color-igluRed-9)',
			});
		},
	});

	return { mutate, isLoading };
};
